import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { COLORS } from '../../constant'
import CDropdown from "../../common/CDropdown";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import {getVehicleInfo}  from '../../api/usedCarLoan'

export default function VehicleInfo(props) {
    const {onHandleInput,data,setAssetValue} = props
    const styles = useStyles();
    const [loading, setLoading] = useState(false)
    const [brandList, setBrandList] = useState([])
    const [modelList, setModelList] = useState([])
    const [makeList, setMakeList] = useState([])
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        actionButton: "",
    });

    const onCloseModal = () => {
        setAlertModalVisible(false);
    };

    const onChange = (key, value) => {
        onHandleInput(key,value)
        if(key == 'brand'){
            const param = {
                type:"getModel",
                value : value
            }
            getVehicleBrandList(param)
        }else if(key == 'model'){
            const param = {
                type:"getMake",
                value : value
            }
            getVehicleBrandList(param)
        }else if(key == 'make'){
            
            
            let temp = makeList.filter(item=>item.value == value)
            if(temp && temp.length){
                setAssetValue(temp[0].assetGroup)
            }
        }
    }
    const getVehicleBrandList = (param) =>{
        setLoading(true)
        var obj = {}
        if(param.type == 'getBrand'){
            obj = {
                type :"brand"
            }
        }else if(param.type == "getModel"){
            obj={
                type:"model",
                brand:param.value
            }
        }else if(param.type == 'getMake'){
            obj={
                type:"make",
                brand : data.brand ,
                model : param.value
            }
        }
        getVehicleInfo(obj)
        .then(res=>{
            setLoading(false)
            if(res.statusCode == 1079){
                const arr = []
                if(param.type == "getBrand"){
                    res.data.map(item => { arr.push({ "label": item.assetValue, "value": item.externalCd  }) })
                    setBrandList(arr)
                }else if(param.type == 'getModel'){
                    res.data.map(item => { arr.push({ "label": item.assetValue, "value": item.externalCd }) })
                    setModelList(arr)
                }else if(param.type == 'getMake'){
                    res.data.map(item => { arr.push({ "label": item.assetValue, "value": item.externalCd,"assetGroup" :item.assetGroup}) })
                    setMakeList(arr)
                }
            }
        })
        .catch(err=>{

        })
    }
    useEffect(()=>{

        const param = {
            type : "getBrand"
        }       
        getVehicleBrandList(param)
    },[])

    

    return (
        <>
            <View style={styles.empInfoWrapper}>
                <View style={[styles.infoWrapper,{zIndex:1  }]}>
                     <CDropdown label="Brand"   
                                value={data.brand}
                                onSelect={value => {
                                    onChange('brand', value)
                                }} 
                                items={brandList}
                                mandatoryField = {true}
                    /> 
                     <CDropdown 
                        label="Model"
                        value={data.model}
                        onSelect={value => onChange('model', value)} 
                        items={modelList}
                        mandatoryField = {true}
                        />
                </View>
                <View style={styles.infoWrapper}>
                     <CDropdown 
                        label="Make" 
                        value={data.make}
                        onSelect={value => onChange('make', value)} 
                        items={makeList}
                        mandatoryField = {true}
                         /> 
                </View>
            </View>
            {alertModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={onCloseModal}
                    />
                </View>
            ) : null}
            {loading && <Loader />}
        </>
    )
}
const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        display: "flex",
        marginLeft: 50,
        paddingLeft: 40,
        paddingTop: 10,
        marginRight: 63
    },
    footer: {
        flexDirection: "row",
        alignSelf: "flex-end",
        width: 220,
        height: 44,
    },
    inputWrapper: {
        marginLeft: "20%"
    },
    panWrapper: {
        flexDirection: "row",
        marginLeft: 0,
        justifyContent: "space-between",
        marginTop: 32
    },
    validateButtonWrapper: {
        height: 44,
        width: 224,
        borderRadius: 22,
        backgroundColor: COLORS.shamrock
    },
    empInfoWrapper: {
        gap: 15,
        marginTop: 32
    },
    infoWrapper: {
        flexDirection: "row",
        gap: 120,
    },
    overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
    },
},
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            inputWrapper: {
                marginLeft: 0,
                marginTop: 63
            },
            contentWrapper: {
                paddingLeft: 0
            },
            footer: {
                alignSelf: "center",
                marginTop:30
            },
            infoWrapper:{
                flexDirection : "column",
                gap : 10
            }
        }
    })